import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';
import { TeamsMenu } from './ui/index.tsx';
import { InvitePeopleModalContextProvider } from './controllers/use-invite-people-modal/index.tsx';

export const Teams = (): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-teams">
		<JSErrorBoundary fallback="flag" id="teams" packageName={PACKAGE_NAME} teamName={TEAM_NAME}>
			<InvitePeopleModalContextProvider>
				<TeamsMenu />
			</InvitePeopleModalContextProvider>
		</JSErrorBoundary>
	</UFOSegment>
);
